import { FEEDER_CABLE_SUGGESTION } from "./constants";
import type { FeederCircuitRows } from "./types";

export const feederCircuitRows: FeederCircuitRows = ({
  feeders,
  lengthsByCircuit,
  cableTypeByCircuit,
  boardName,
  title,
}) =>
  Object.entries(feeders).map(([circuitId, feeder]) => ({
    item: circuitId,
    text: title(boardName(feeder.toLabel), cableTypeByCircuit[circuitId] !== undefined),
    quantity: lengthsByCircuit[circuitId] ?? 0,
    unit: "m",
    cable_type: cableTypeByCircuit[circuitId] ?? FEEDER_CABLE_SUGGESTION,
    board: boardName(feeder.fromLabel),
    circuit: circuitId,
    device_count: 1,
  }));
